import { computed } from 'vue';
import { rawDynamicImport } from '@app/helpers/memberships/section';
import { data } from '@app/memberships/state/store';

export default function(validate, form){
    return {
        title     : 'User details',
        component : rawDynamicImport(() => import('@app/memberships/components/form/stages/user_details/UserDetails.vue')),
        isValid   : computed(
            () => data.user.is_authenticated.value || validate({
                'user.name'               : ['required'],
                'user.email'              : ['required', 'email'],
                'user.email_confirmation' : ['required', 'email']
            })
        ),
        data: computed(
            () => ({
                user: {
                    name               : form.value?.user?.name,
                    email              : form.value?.user?.email,
                    email_confirmation : form.value?.user?.email_confirmation,
                }
            })
        ),
        onReloadData : (progression) => {
            form.value.user = progression.data.user
        },
        listeners    : {}
    }
}